/**
 * used to quickly unwrap {@link ValueOrArray} instances into an array
 *
 * many times its nice from a parameter perspective to allow a value or array
 * of values, but it can be tedius to unwrap the parameter into an array
 *
 * @param valueOrArray
 * @see {@link ValueOrArray}
 */
export function resolveValueOrArray<T>(valueOrArray: ValueOrArray<T>) {
  return Array.isArray(valueOrArray) ? valueOrArray : [valueOrArray]
}

/**
 * a shortcut type to define a single value or array of values
 */
export type ValueOrArray<T> = T | T[]
